<template>
  <div id="list">
    <!-- FORM MODAL -->
    <modal name="form"
           height="auto"
           :scrollable="true"
           :adaptive="true">
      <button type="button" class="close" aria-label="Close" @click="hide" style="margin-right: 10px; margin-top: 5px;">
        <span aria-hidden="true">&times;</span>
      </button>
      <p class="forma-m mt-4">Mi vjerujemo da su čuda moguća, jer iz dana u dan svjedočimo velikim pomacima djece koja su toplinu porodičnog doma pronašla u SOS porodici.</p>
      <p class="forma-m">Pozivamo vas da na SOS zvjezdanom nebu, zvijezdi date sjaj i pomognete u ostvarivanju jedne od novogodišnjih želja za 240 dječaka i djevojčica.</p>
      <p class="forma-m">Djeca su zvijezdice koja su svojim osmijesima dokazali da su čuda moguća.</p>
      <p class="forma-m">Donirajte i zvijezda sa vašim imenom će se pojaviti na ovom komadiću neba!</p>
      <b-form @submit="submitDonation" style="margin: 20px;">
        <b-form inline>
          <!--<label class="sr-only" for="name">Name</label>-->
          <b-form-input class="col-md-6 mr-2 mb-2"
                        type="text"
                        id="name"
                        placeholder="Unesite ime"
                        required
                        v-model="name">
          </b-form-input>
          <!--<label class="sr-only" for="address">Username</label>-->
          <b-input class="col-md-5 mb-2"
                   type="text"
                   v-model="address"
                   required
                   placeholder="Unesite adresu"
                   id="address">
          </b-input>
        </b-form>

        <b-form inline>
          <!--<label class="sr-only" for="city">Name</label>-->
          <b-form-input class="col-md-5 mr-2 mb-2"
                        id="city"
                        type="text"
                        v-model="city"
                        required
                        placeholder="Unesite grad">>
          </b-form-input>
          <!--<label class="sr-only" for="country">Username</label>-->
          <b-input class="col-md-6 mb-2"
                   id="country"
                   type="text"
                   v-model="country"
                   required
                   placeholder="Unesite državu"></b-input>
        </b-form>
        <b-form inline>
            <b-form-input class="col-md-8 mr-2 mb-2" id="message"
                          type="text"
                          v-model="message"
                          placeholder="Unesite vašu poruku">
            </b-form-input>
            <b-form-input class="col-md-3 mb-2"
                          type="number"
                          id="amount"
                          v-model="amount"
                          required
                          placeholder="Iznos u KM">
            </b-form-input>
        </b-form>
        <b-button type="submit" variant="primary">Doniraj</b-button>
      </b-form>
    </modal>
    <div class="topline">
      <div class="container">
        <a href="https://www.sos-ds.ba/" class="icon-logo sos-logo">
          <img src="@/assets/sos-logo.png" alt="">
        </a>
        <div class="header_stat_col">
          <div class="header_stat_item">
            Broj zvijezda: <b class="blue">{{counter}}</b>
          </div>
          <div class="header_stat_item">
            Prikupili smo: <b class="blue">{{sum}}</b>&nbsp;KM.<br>
          </div>
          <ul class="topline-soc">
            <li class="topline-soc_item"><a href="https://www.facebook.com/sosdjecijeselo.bih" target="_blank"><i class="fab fa-facebook"></i></a></li>
            <li class="topline-soc_item"><a href="https://twitter.com/sosdsbih" target="_blank"><i class="fab fa-twitter"></i></a></li>
            <li class="topline-soc_item"><a href="https://www.linkedin.com/company/sos-djecija-sela-bih" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
            <li class="topline-soc_item"><a href="https://www.instagram.com/sosdjecijaselabih/" target="_blank"><i class="fab fa-instagram"></i></a></li>
            <li class="topline-soc_item"><a href="https://www.youtube.com/user/sosdsbih" target="_blank"><i class="fab fa-youtube"></i></a></li>
          </ul>
        </div>
      </div>

    </div>

    <div class="main">
      <!--<div id="animation_container" style="background-color:transparent; width:854px; height:271px">-->
        <!--<canvas id="canvas" width="854" height="271" style="position: absolute; display: block; background-color:transparent;"></canvas>-->
        <!--<div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:854px; height:271px; position: absolute; left: 0px; top: 0px; display: block;">-->
        <!--</div>-->
      <!--</div>-->

      <div class="snow_effect"></div>

      <div class="container">
        <div class="page-header"><h3>Novogodišnja čarolija je u rukama svakog od nas!</h3>
          Donirajte i dajte zvijezdi sjaj. Vidjećete kako se zvijezda sa vašim imenom pojavljuje na ovom komadiću neba,
          <br>a novogodišnje želje ostvaruju za 240 dječaka i djevojčica.</div>
        <form style="visibility: hidden;" action="https://ecomm.rbbh.ba:9443/ecomm2/ClientHandler" method="POST" name="returnForm" id="returnForm">
          <input name="trans_id" id="input_value">
        </form>
        <div class="main_btn" @click="show">Doniraj</div>
      </div>

      <div>
        <!--Stars-->
        <span :id="'popover' + donation.id" :style="{top: donation.top + '%', right: donation.right + '%'}" style="position: absolute; z-index: 2;" class="donator-star" v-for="donation of donations" :key="donation.id">
          <img :class="checkDonation(donation.amount)" src="@/assets/donator-star.png" alt="">
          <b-popover :target="'popover' + donation.id" triggers="hover">
            <template slot="title">{{donation.name}}</template>
            Donacija: {{donation.amount}} KM<span v-if="donation.message"><hr>Poruka: {{donation.message}}</span>
          </b-popover>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
require('es6-promise').polyfill()
let axios = require('axios')
export default {
  name: 'HelloWorld',
  components: {},

  data () {
    return {
      counter: 0,
      sum: 0,
      donations: [],
      name: '',
      address: '',
      city: '',
      country: '',
      amount: null,
      message: '',
      positions: []
    }
  },
  created () {
    this.fetchApi()
  },
  methods: {
    show () {
      this.$modal.show('form')
    },
    hide () {
      this.$modal.hide('form')
    },
    fetchApi () {
      let api = 'https://api.sos-ds.ba/api'
      let vm = this
      axios.get(api + '/new-year-counter').then(function (response) {
        vm.counter = response.data[0].newYearsDonations
      })
      axios.get(api + '/new-year-sum').then(function (response) {
        vm.sum = response.data[0].donationsAmount
      })
      axios.get(api + '/new-year-positions').then(function (response) {
        vm.donations = response.data
        vm.donations.forEach(function (donation) {
          vm.positions.push({
            top: donation.top,
            right: donation.right
          })
        })
      })
    },
    checkDonation (amount) {
      if (amount < 10) {
        return 'smallDonation'
      } else if (amount < 100) {
        return 'mediumDonation'
      } else {
        return 'largeDonation'
      }
    },
    generateRandomNumber (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    submitDonation (event) {
      event.preventDefault()
      let vm = this
      let top = 0
      let right = 0
      do {
        top = vm.generateRandomNumber(24, 40)
        right = vm.generateRandomNumber(0, 100)
      } while (vm.positions.indexOf({top: top, right: right}) !== -1)
      axios.post('https://api.sos-ds.ba/api/donations', {
        name: this.name,
        address: this.address,
        city: this.city,
        country: this.country,
        amount: this.amount,
        message: this.message,
        newsletter: false,
        new_year: true,
        top: top,
        right: right
      })
        .then(function (response) {
          let transID = response.data.transaction_id
          let redirectForm = document.getElementById('returnForm')
          let inputValue = document.getElementById('input_value')
          inputValue.value = transID
          redirectForm.submit()
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .donator-star {
    position: absolute;
    -webkit-filter: drop-shadow(0px 0px 0px #000 );
    filter: drop-shadow(0px 0px 0px #000);

    animation: SunFire 1s linear infinite alternate;
  }
  .donator-star:hover {
    filter: drop-shadow(0px 0px 0px #fff);
  }
  .smallDonation {
    width: 20px;
  }
  .mediumDonation {
    width: 25px;
  }
  .largeDonation {
    width: 30px;
  }
  .sos-logo img {
    width: 200px;
    height: 42px;
  }
  .forma-m {
    margin-left: 20px;
    margin-right: 20px;
  }
  .page-header {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    #city {
      margin-right: 50px;
    }
    #country {
      margin-right: 8px;
    }
    #address {
      margin-right: 8px;
    }
    #amount {
      margin-right: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue